var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTreeBlue = function SvgTreeBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#TreeBlue_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#123862"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.333 16.36a1.456 1.456 0 0 0-.083-.05v-3.846l4.085-2.043a.75.75 0 1 0-.67-1.342l-3.415 1.708V8.25a.75.75 0 0 0-1.5 0v4.786L8.335 11.33a.75.75 0 0 0-.67 1.342l4.085 2.043v1.596a1.429 1.429 0 0 0-.084.05l-.01.008a5.251 5.251 0 0 1-7.94-5.99 5.25 5.25 0 0 1 2.867-3.155c.322-.162.578-.43.724-.76l.006-.013a5.625 5.625 0 0 1 10.373 0l.006.013a1.556 1.556 0 0 0 .754.775 5.249 5.249 0 1 1-5.102 9.13l-.01-.007Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.5 1.502a7.125 7.125 0 0 0-6.565 4.356.056.056 0 0 1-.02.022 6.75 6.75 0 1 0 5.835 12.17v3.7a.75.75 0 0 0 1.5 0v-3.7a6.752 6.752 0 0 0 8.942-2.729 6.75 6.75 0 0 0-3.108-9.441.056.056 0 0 1-.02-.022A7.125 7.125 0 0 0 12.5 1.502Zm.75 14.807.083.051.01.008a5.25 5.25 0 1 0 5.073-9.145 1.556 1.556 0 0 1-.724-.76l-.006-.013a5.625 5.625 0 0 0-10.373 0l-.006.013a1.556 1.556 0 0 1-.754.775 5.25 5.25 0 1 0 5.103 9.13l.01-.008c.027-.017.055-.034.084-.05v-1.596L7.664 12.67a.75.75 0 1 1 .671-1.342l3.415 1.707V8.25a.75.75 0 0 1 1.5 0v2.537l3.414-1.708a.75.75 0 0 1 .671 1.342l-4.085 2.043v3.845Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 18.05v-3.337l-4.085-2.042a.75.75 0 1 1 .67-1.342l3.415 1.707V8.25a.75.75 0 0 1 1.5 0v2.537l3.415-1.708a.75.75 0 0 1 .67 1.342l-4.085 2.043v9.286a.75.75 0 0 1-1.5 0v-3.7Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "TreeBlue_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgTreeBlue;